module.exports = __webpack_public_path__ + "img/fujiannongye.801ee2f5.png";